export type AgentMode = "cascade" | "direct" | "liveavatar";

export const DEFAULT_AGENT_MODE: AgentMode = "cascade";

export const DIRECT_MODEL_DEFAULT = "gpt-live-1";

/**
 * GPT-Live session voices (API-fixed at session start).
 * API names from OpenAI GPT-Live voice catalog (marin/cedar + 12 accents).
 */
export const DIRECT_VOICE_OPTIONS = [
  { value: "marin", label: "Marin · Feminine" },
  { value: "quartz", label: "Quartz · Feminine · Australian" },
  { value: "willow", label: "Willow · Feminine · Irish" },
  { value: "gleam", label: "Gleam · Feminine · North American" },
  { value: "bossa", label: "Bossa · Feminine · Brazilian Portuguese" },
  { value: "delta", label: "Delta · Feminine · Southern U.S." },
  { value: "cedar", label: "Cedar · Masculine" },
  { value: "ripple", label: "Ripple · Masculine · Australian" },
  { value: "vesper", label: "Vesper · Masculine · British" },
  { value: "stone", label: "Stone · Masculine · Irish" },
  { value: "meridian", label: "Meridian · Masculine · North American" },
  { value: "tempo", label: "Tempo · Masculine · Brazilian Portuguese" },
  { value: "beacon", label: "Beacon · Masculine · Filipino English" },
  { value: "cinder", label: "Cinder · Masculine · Southern U.S." },
] as const;

export const DIRECT_VOICE_DEFAULT = "marin";

export const DIRECT_VOICE_IDS = DIRECT_VOICE_OPTIONS.map((o) => o.value);

export function normalizeAgentMode(raw: unknown): AgentMode {
  const v = String(raw || "").trim().toLowerCase();
  if (v === "direct") return "direct";
  if (v === "liveavatar" || v === "live_avatar" || v === "live-avatar") return "liveavatar";
  return "cascade";
}

export function agentModeLabel(mode: AgentMode): string {
  if (mode === "direct") return "Direct";
  if (mode === "liveavatar") return "LiveAvatar";
  return "Cascade";
}

export function normalizeDirectModel(raw: unknown): string {
  const v = String(raw || "").trim();
  return v || DIRECT_MODEL_DEFAULT;
}

export function normalizeDirectVoice(raw: unknown): string {
  const v = String(raw || "").trim().toLowerCase();
  if (DIRECT_VOICE_IDS.includes(v as (typeof DIRECT_VOICE_IDS)[number])) return v;
  return DIRECT_VOICE_DEFAULT;
}
